import React from "react";
import { Modal, Button, Switch, Icon, Badge, Spin, notification, Typography } from "antd";
import moment from "moment";
import Request, { MEDIA_URL } from "../../request";
import _ from 'lodash';

const { Text } = Typography;

class InquiryReviewModal extends React.Component {
    state = {
        loading: false,
        actionLoading: false,
        inquiryDetail: null,
        verificationState: {
            studentRecord: false,
            intakeDate: false,
            tutionFeeAmount: false,
            tutionFeePayment: false,
            universityOrCPinformation: false,
            branchOrApinformation: false,
            swiftCopy: false,
            piInvoiceCount: false,
            piInvoiceAmount: false
        }
    }

    componentDidMount() {
        if (this.props.inquiryId) {
            this.fetchInquiryDetails();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.inquiryId !== prevProps.inquiryId && this.props.inquiryId) {
            this.fetchInquiryDetails();
        }
    }

    fetchInquiryDetails = async () => {
        this.setState({ loading: true });
        let response = await Request.getInquiryVerificationDetails({ _id: this.props.inquiryId });
        this.setState({ loading: false });

        if (response && response.success && response.doc) {
            this.setState({
                inquiryDetail: response.doc,
                verificationState: {
                    studentRecord: false,
                    intakeDate: false,
                    tutionFeeAmount: false,
                    tutionFeePayment: false,
                    universityOrCPinformation: false,
                    branchOrApinformation: false,
                    swiftCopy: false,
                    piInvoiceCount: false,
                    piInvoiceAmount: false
                }
            });
        } else {
            notification.error({
                message: 'Failed to fetch verification details'
            });
            this.props.onClose();
        }
    }

    handleSwitchChange = (key, checked) => {
        this.setState(prevState => ({
            verificationState: {
                ...prevState.verificationState,
                [key]: checked
            }
        }));
    }

    isAllVerified = () => {
        const { verificationState, inquiryDetail } = this.state;
        if (!inquiryDetail) return false;

        const hasInvoiceDetails = inquiryDetail.invoiceReviewDetails ? true : false;
        let requiredKeys = [
            'studentRecord', 'intakeDate', 'tutionFeeAmount',
            'tutionFeePayment', 'universityOrCPinformation',
            'branchOrApinformation', 'swiftCopy'
        ];

        if (hasInvoiceDetails) {
            requiredKeys.push('piInvoiceCount', 'piInvoiceAmount');
        }

        return requiredKeys.every(key => verificationState[key] === true);
    }

    handleModalRollback = async () => {
        const { inquiryDetail } = this.state;
        const _id = inquiryDetail._id || inquiryDetail.id;

        // 1. यूज़र से रोलबैक का कारण पूछें
        let rejectionReason = prompt('Enter Reason For Rollback (Visa Desk):');

        // अगर यूज़र कैंसिल कर दे या खाली छोड़ दे तो एरर दिखाएं
        if (!rejectionReason || !rejectionReason.trim()) {
            notification.error({ message: 'Enter Reason For Rollback' });
            return;
        }

        // 2. पेलोड तैयार करें जहाँ atLevel हमेशा 'Visa Desk' रहेगा
        let values = {
            _id,
            atLevel: 'Visa Desk', // फिक्स लेवल ताकि सीधा वीज़ा डेस्क पर जाए
            rejectReason: rejectionReason.trim()
        };

        this.setState({ actionLoading: true });

        // 3. आपकी ड्रावर वाली रिजेक्ट/रोलबैक एपीआई को सीधे कॉल करें
        let response = await Request.rejectMoveToClaimRequest(values);

        this.setState({ actionLoading: false });

        if (response.success) {
            notification.success({
                message: response.message || 'Student rolled back to Visa Desk successfully.'
            });
            this.props.onSuccess(); // पैरेंट टेबल को रीलोड करने और मोडल क्लोज करने के लिए
        } else {
            notification.error({
                message: response.message || 'Failed to rollback student.'
            });
        }
    }

    // ✅ आपका नया सबमिट और अप्रूव मेथड यहाँ कंबाइन किया गया है
    handleModalApprove = async () => {
        const { inquiryDetail, verificationState } = this.state;
        const _id = inquiryDetail._id || inquiryDetail.id;

        const requiredFields = [
            'studentRecord', 'intakeDate', 'tutionFeeAmount',
            'tutionFeePayment', 'universityOrCPinformation',
            'branchOrApinformation', 'swiftCopy',
            'piInvoiceCount', 'piInvoiceAmount'
        ];

        let allVerified = requiredFields.every(key => verificationState[key] === true);

        let valData = _.clone(verificationState);
        valData.reviewStatus = allVerified ? 'Verified' : 'Under Review';

        let values = {
            _id,
            valData: { invoiceReviewDetails: valData }
        };

        this.setState({ actionLoading: true });

        // 1. पहले इंक्वायरी के रिव्यू डिटेल्स को अपडेट (सेव) करेंगे
        let updateResponse = await Request.updateInquiry(values);
        this.setState({ actionLoading: false });

        if (updateResponse.success) {
            // 2. सक्सेस होने पर पैरेंट को इन्फॉर्म करेंगे ताकि वो मोडल क्लोज करके चेक एपीआई चला सके
            this.props.onSuccess(_id);
        } else {
            notification.error({
                message: updateResponse.msg || 'Failed to update inquiry verification log metadata'
            });
        }
    }

    render() {
        const { visible, onClose } = this.props;
        const { loading, actionLoading, inquiryDetail, verificationState } = this.state;
        const allVerified = this.isAllVerified();

        const tableStyle = { width: '100%', marginBottom: '15px', border: '1px solid #f0f0f0', borderRadius: '4px' };
        const labelStyle = { padding: '10px', background: '#fafafa', width: '25%', fontWeight: 600, color: '#434343' };
        const valueStyle = { padding: '10px', width: '25%', color: '#262626' };
        const switchRowStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f6ffed', padding: '8px 12px', borderRadius: '4px', border: '1px solid #b7eb8f', marginTop: '-10px', marginBottom: '15px' };

        let formattedIntake = '-';
        if (inquiryDetail && inquiryDetail.courseStartDate) {
            formattedIntake = moment(inquiryDetail.courseStartDate).format("MMM-YYYY");
        }

        const comm = inquiryDetail && inquiryDetail.commissionDetails
            ? inquiryDetail.commissionDetails
            : {};

        const offerFile = inquiryDetail && inquiryDetail.offerLetter ? inquiryDetail.offerLetter : null;
        const feeFile = inquiryDetail && inquiryDetail.feeReceipt && inquiryDetail.feeReceipt.length > 0 ? inquiryDetail.feeReceipt[0] : null;
        const swiftFile = inquiryDetail && inquiryDetail.swiftCopy && inquiryDetail.swiftCopy.length > 0 ? inquiryDetail.swiftCopy[0] : null;
        const visaFile = inquiryDetail && inquiryDetail.visaUpload && inquiryDetail.visaUpload[0] ? inquiryDetail.visaUpload[0] : null;
        const agreementFile = inquiryDetail && inquiryDetail.agreementFile && inquiryDetail.agreementFile[0] ? inquiryDetail.agreementFile[0] : null;
        const routePipeline = inquiryDetail && inquiryDetail.channelPartnerName ? inquiryDetail.channelPartnerName : 'Direct Recruitment';

        return (
            <Modal
                title={
                    <div style={{ fontSize: '16px', fontWeight: 600 }}>
                        <Icon type="security-scan" style={{ marginRight: 8, color: '#1890ff' }} />
                        Advanced Core Verification & Comprehensive Document Review
                    </div>
                }
                visible={visible}
                width={850}
                onCancel={onClose}
                style={{ top: 40 }} // ✅ मोडल को स्क्रीन पर थोड़ा ऊपर शिफ्ट करेगा ताकि हाइट पूरी मिल सके
                bodyStyle={{ maxHeight: 'calc(100vh - 140px)', overflowY: 'auto', padding: '20px' }} // ✅ यहाँ हाइट बढ़ा दी गई है (-220px से बदलकर -140px किया)
                footer={[
                    <Button key="close" onClick={onClose} disabled={actionLoading}>
                        Cancel
                    </Button>,
                    <Button
                        key="rollback"
                        type="danger"
                        disabled={loading || actionLoading}
                        style={{ backgroundColor: '#fff1f0', color: '#f5222d', borderColor: '#ffa39e' }}
                        onClick={this.handleModalRollback}
                    >
                        <Icon type="rollback" /> Rollback to Visa Desk
                    </Button>,
                    allVerified && (
                        <Button
                            key="approve"
                            type="primary"
                            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                            loading={actionLoading}
                            onClick={this.handleModalApprove}
                        >
                            <Icon type="check-circle" /> Approve & Move to Claim Desk
                        </Button>
                    )
                ]}
            >
                <Spin spinning={loading} tip="Fetching Specific Verification Records...">
                    {inquiryDetail ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>

                            {/* 1. Student Identity Records */}
                            <div style={{ border: '1px solid #e8e8e8', borderRadius: '6px', padding: '14px', background: '#fff' }}>
                                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#1890ff', marginBottom: '12px' }}>
                                    <Icon type="profile" style={{ marginRight: 6 }} /> 1. Student Personal Identity Profile Records
                                </h4>
                                <table className="ant-table" style={tableStyle}>
                                    <tbody className="ant-table-tbody">
                                        <tr>
                                            <td style={labelStyle}>Student Full Name</td>
                                            <td style={valueStyle}>{inquiryDetail.studentName || '-'}</td>
                                            <td style={labelStyle}>Date of Birth (DOB)</td>
                                            <td style={valueStyle}>{inquiryDetail.dateOfBirth ? moment(inquiryDetail.dateOfBirth).format("DD-MMM-YYYY") : '-'}</td>
                                        </tr>
                                        <tr>
                                            <td style={labelStyle}>Passport Number</td>
                                            <td style={valueStyle}>{inquiryDetail.passportNumber || '-'}</td>
                                            <td style={labelStyle}>Institute Student ID</td>
                                            <td style={valueStyle}>{inquiryDetail.instituteStudentId || inquiryDetail.visaDesk.selectedCourse.instituteStudentId || '-'}</td>
                                        </tr>
                                        {/* ✅ यहाँ नया Branch Name फ़ील्ड जोड़ दिया गया है */}
                                        <tr>
                                            <td style={labelStyle}>Branch/Sub Agent</td>
                                            <td style={valueStyle}>{inquiryDetail.branchName || '-'}</td>
                                            <td style={labelStyle}></td>
                                            <td style={valueStyle}></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={switchRowStyle}>
                                    <span style={{ fontSize: '12px', fontWeight: 500, color: '#1e4620' }}>I confirm that the Student Identity Profile and Passport match perfectly</span>
                                    <Switch checked={verificationState.studentRecord} onChange={(v) => this.handleSwitchChange('studentRecord', v)} />
                                </div>
                            </div>

                            {/* 2. Intake & Course Session */}
                            <div style={{ border: '1px solid #e8e8e8', borderRadius: '6px', padding: '14px', background: '#fff' }}>
                                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#fa8c16', marginBottom: '12px' }}>
                                    <Icon type="calendar" style={{ marginRight: 6 }} /> 2. Academic Enrollment & Intake Session Timelines
                                </h4>
                                <table className="ant-table" style={tableStyle}>
                                    <tbody className="ant-table-tbody">
                                        <tr>
                                            <td style={labelStyle}>University Name</td>
                                            <td style={valueStyle}><strong>{inquiryDetail.universityName}</strong></td>
                                            <td style={labelStyle}>Course Name</td>
                                            <td style={valueStyle}>{inquiryDetail.courseName || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td style={labelStyle}>Intake Session</td>
                                            <td style={valueStyle}><strong>{formattedIntake}</strong></td>
                                            <td style={labelStyle}>Course Start Date</td>
                                            <td style={valueStyle}>{inquiryDetail.courseStartDate ? moment(inquiryDetail.courseStartDate).format("DD-MMM-YYYY") : '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={switchRowStyle}>
                                    <span style={{ fontSize: '12px', fontWeight: 500, color: '#1e4620' }}>I confirm that the Intake Session and Course Timeline have been cross-checked</span>
                                    <Switch checked={verificationState.intakeDate} onChange={(v) => this.handleSwitchChange('intakeDate', v)} />
                                </div>
                            </div>

                            {/* 3. Tuition Fee Breakdown */}
                            <div style={{ border: '1px solid #e8e8e8', borderRadius: '6px', padding: '14px', background: '#fff' }}>
                                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#13c2c2', marginBottom: '12px' }}>
                                    <Icon type="dollar" style={{ marginRight: 6 }} /> 3. Institutional Tuition Fee & Document Attachments
                                </h4>
                                <table className="ant-table" style={tableStyle}>
                                    <tbody className="ant-table-tbody">
                                        <tr>
                                            <td style={labelStyle}>Course Tuition Fee</td>
                                            <td style={valueStyle}>{inquiryDetail.currency || 'USD'} {Number(inquiryDetail.courseTutionFee || inquiryDetail.tutionFee || 0).toFixed(2)}</td>
                                            <td style={labelStyle}>Offer Letter File</td>
                                            <td style={valueStyle}>
                                                {offerFile && offerFile.url ? (
                                                    <a href={`${MEDIA_URL}${offerFile.url}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', fontWeight: 500 }}>
                                                        <Icon type="file-pdf" /> View Offer Letter
                                                    </a>
                                                ) : <span style={{ color: '#bfbfbf' }}>No File Found</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={labelStyle}>Visa Letter File</td>
                                            <td style={valueStyle} colSpan={3}>
                                                {visaFile && visaFile.url ? (
                                                    <a href={`${MEDIA_URL}${visaFile.url}`} target="_blank" rel="noopener noreferrer" style={{ color: '#52c41a', fontWeight: 500 }}>
                                                        <Icon type="file-protect" /> View Visa Letter
                                                    </a>
                                                ) : <span style={{ color: '#bfbfbf' }}>No Document</span>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={switchRowStyle}>
                                    <span style={{ fontSize: '12px', fontWeight: 500, color: '#1e4620' }}>I confirm the Tuition Fee and uploaded Core Letters match perfectly</span>
                                    <Switch checked={verificationState.tutionFeeAmount} onChange={(v) => this.handleSwitchChange('tutionFeeAmount', v)} />
                                </div>
                            </div>

                            {/* 4. Tuition Fee Bank Proofs */}
                            <div style={{ border: '1px solid #e8e8e8', borderRadius: '6px', padding: '14px', background: '#fff' }}>
                                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#52c41a', marginBottom: '12px' }}>
                                    <Icon type="file-done" style={{ marginRight: 6 }} /> 4. Tuition Fee Remittance Bank Receipts Proof
                                </h4>
                                <table className="ant-table" style={tableStyle}>
                                    <tbody className="ant-table-tbody">
                                        <tr>
                                            <td style={labelStyle}>Fee Receipt Document</td>
                                            <td style={{ ...valueStyle, width: '75%' }} colSpan={3}>
                                                {feeFile && feeFile.url ? (
                                                    <a href={`${MEDIA_URL}${feeFile.url}`} target="_blank" rel="noopener noreferrer" style={{ color: '#722ed1', fontWeight: 500 }}>
                                                        <Icon type="file-text" /> Open Fee Remittance Receipt ({feeFile.name || 'PDF'})
                                                    </a>
                                                ) : <span style={{ color: '#bfbfbf' }}>No Receipt Document Attached</span>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={switchRowStyle}>
                                    <span style={{ fontSize: '12px', fontWeight: 500, color: '#1e4620' }}>I confirm that the Bank Payment Remittance Receipt is legitimate and verified</span>
                                    <Switch checked={verificationState.tutionFeePayment} onChange={(v) => this.handleSwitchChange('tutionFeePayment', v)} />
                                </div>
                            </div>

                            {/* 5. University Info */}
                            <div style={{ border: '1px solid #e8e8e8', borderRadius: '6px', padding: '14px', background: '#fff' }}>
                                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#eb2f96', marginBottom: '12px' }}>
                                    <Icon type="bank" style={{ marginRight: 6 }} /> 5. Destination University & Channel Partner Mapping Info
                                </h4>
                                <table className="ant-table" style={tableStyle}>
                                    <tbody className="ant-table-tbody">
                                        <tr>
                                            <td style={labelStyle}>University Name</td>
                                            <td style={valueStyle}>{inquiryDetail.universityName || '-'}</td>
                                            <td style={labelStyle}>Recruitment Pipeline</td>
                                            <td style={valueStyle}><Badge status={routePipeline === 'Direct Recruitment' ? 'default' : 'processing'} text={routePipeline} /></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={switchRowStyle}>
                                    <span style={{ fontSize: '12px', fontWeight: 500, color: '#1e4620' }}>I confirm that University & Route details are correct</span>
                                    <Switch checked={verificationState.universityOrCPinformation} onChange={(v) => this.handleSwitchChange('universityOrCPinformation', v)} />
                                </div>
                            </div>

                            {/* 6. Commission Details Breakdown */}
                            <div style={{ border: '1px solid #e8e8e8', borderRadius: '6px', padding: '14px', background: '#fff' }}>
                                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#722ed1', marginBottom: '12px' }}>
                                    <Icon type="branches" style={{ marginRight: 6 }} /> 6. Contractual Commission Allocation Breakdown
                                </h4>
                                <table className="ant-table" style={tableStyle}>
                                    <tbody className="ant-table-tbody">
                                        <tr>
                                            <td style={labelStyle}>Total Invoice (No. of Inv)</td>
                                            <td style={valueStyle}>{comm.noOfInvoice || '-'}</td>
                                            <td style={labelStyle}>Invoice Per Year</td>
                                            <td style={valueStyle}>{comm.invoicePerYear || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td style={labelStyle}>Commission Status</td>
                                            <td style={valueStyle}><Badge status={comm.status === 'Active' ? 'success' : 'default'} text={comm.status || '-'} /></td>
                                            <td style={labelStyle}>Type of Commission</td>
                                            <td style={valueStyle}>{comm.typeOfCommission || '-'}</td>
                                        </tr>
                                        {
                                            comm.commDetails && comm.commDetails.length > 0 ? (
                                                comm.commDetails.map(function (item, index) {
                                                    return (
                                                        <tr key={index}>
                                                            <td style={labelStyle}>
                                                                Commission Type (Term {item.term})
                                                            </td>

                                                            <td style={valueStyle}>
                                                                {item.commissionTypeFrom || 'Flat'}
                                                            </td>

                                                            <td style={labelStyle}>
                                                                Commission From Uni
                                                            </td>

                                                            <td style={valueStyle}>
                                                                <strong>
                                                                    {item.commissionTypeFrom === 'Percentage'
                                                                        ? item.commissionFromUniversity + '%'
                                                                        : (inquiryDetail.currency || 'USD') +
                                                                        ' ' +
                                                                        Number(item.commissionFromUniversity || 0).toFixed(2)}
                                                                </strong>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td style={labelStyle}>Commission Type (From)</td>
                                                    <td style={valueStyle}>{comm.commissionTypeFrom || 'Flat'}</td>

                                                    <td style={labelStyle}>Commission From Uni</td>
                                                    <td style={valueStyle}>
                                                        <strong>
                                                            {(inquiryDetail.currency || 'USD') +
                                                                ' ' +
                                                                Number(comm.commissionFromUniversity || 0).toFixed(2)}
                                                        </strong>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        <tr>
                                            <td style={labelStyle}>Agreement Comm. Page</td>
                                            <td style={valueStyle} colSpan={3}>
                                                {agreementFile && agreementFile.url ? (
                                                    <a href={`${MEDIA_URL}${agreementFile.url}`} target="_blank" rel="noopener noreferrer" style={{ color: '#fa8c16', fontWeight: 500 }}>
                                                        <Icon type="file-excel" style={{ marginRight: 4 }} /> View Contract Agreement Commission Page
                                                    </a>
                                                ) : <span style={{ color: '#bfbfbf' }}>No Document Attached</span>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={switchRowStyle}>
                                    <span style={{ fontSize: '12px', fontWeight: 500, color: '#722ed1' }}>I confirm the University Contractual Payout and Invoice Counter map correctly</span>
                                    <Switch checked={verificationState.branchOrApinformation} onChange={(v) => this.handleSwitchChange('branchOrApinformation', v)} />
                                </div>
                            </div>

                            {/* 7. Swift Copy Bank Reference */}
                            <div style={{ border: '1px solid #e8e8e8', borderRadius: '6px', padding: '14px', background: '#fff' }}>
                                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#2f54eb', marginBottom: '12px' }}>
                                    <Icon type="swap" style={{ marginRight: 6 }} /> 7. International Wire Transfer Reference (Swift Copy Record)
                                </h4>
                                <table className="ant-table" style={tableStyle}>
                                    <tbody className="ant-table-tbody">
                                        <tr>
                                            <td style={labelStyle}>Swift Copy Wire Doc</td>
                                            <td style={{ ...valueStyle, width: '75%' }} colSpan={3}>
                                                {swiftFile && swiftFile.url ? (
                                                    <a href={`${MEDIA_URL}${swiftFile.url}`} target="_blank" rel="noopener noreferrer" style={{ color: '#13c2c2', fontWeight: 500 }}>
                                                        <Icon type="link" /> View Wire Transfer Swift Reference ({swiftFile.name || 'PDF'})
                                                    </a>
                                                ) : <span style={{ color: '#bfbfbf' }}>No Wire Transfer File Found</span>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={switchRowStyle}>
                                    <span style={{ fontSize: '12px', fontWeight: 500, color: '#2f54eb' }}>I confirm the International Bank Wire (Swift Copy) log is checked</span>
                                    <Switch checked={verificationState.swiftCopy} onChange={(v) => this.handleSwitchChange('swiftCopy', v)} />
                                </div>
                            </div>

                            {/* 8 & 9. Proforma Invoice Validation (Conditional) */}
                            {inquiryDetail.invoiceReviewDetails && (
                                <div style={{ border: '1px solid #e8e8e8', borderRadius: '6px', padding: '14px', background: '#fff' }}>
                                    <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#ff4d4f', marginBottom: '12px' }}>
                                        <Icon type="ordered-list" style={{ marginRight: 6 }} /> 8 & 9. Auto-Generated Proforma Invoice (PI) Financial Validation
                                    </h4>
                                    <table className="ant-table" style={tableStyle}>
                                        <tbody className="ant-table-tbody">
                                            <tr>
                                                <td style={labelStyle}>PI Generation Count</td>
                                                <td style={valueStyle}>{inquiryDetail.invoiceReviewDetails.piCount || '1 Record Pending'}</td>
                                                <td style={labelStyle}>PI Total Value Validation</td>
                                                <td style={valueStyle}><strong>{inquiryDetail.currency || 'USD'} {Number(inquiryDetail.invoiceReviewDetails.piAmountTotal || comm.commissionFromUniversity || 0).toFixed(2)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', background: '#fff1f0', padding: '10px', borderRadius: '4px', border: '1px solid #ffa39e' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontSize: '12px', fontWeight: 500, color: '#a8071a' }}>Confirm Proforma Invoice Target Generation Counter Matrix:</span>
                                            <Switch checked={verificationState.piInvoiceCount} onChange={(v) => this.handleSwitchChange('piInvoiceCount', v)} />
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #ffa39e', paddingTop: '6px' }}>
                                            <span style={{ fontSize: '12px', fontWeight: 500, color: '#a8071a' }}>Confirm Proforma Invoice Final Total Value Amount Metrics:</span>
                                            <Switch checked={verificationState.piInvoiceAmount} onChange={(v) => this.handleSwitchChange('piInvoiceAmount', v)} />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{ height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Text type="secondary">No layout data returned from endpoint configuration criteria.</Text>
                        </div>
                    )}
                </Spin>
            </Modal>
        )
    }
}

export default InquiryReviewModal;